import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import Article, { Title, Excerpt, Content } from './Article';
import { PrimaryLinkButton } from './Buttons';

const StyledArticle = styled(Article)`
  text-align: center;
  padding-top: 80px;
`;

export default function NotFoundArticle() {
  return (
    <StyledArticle>
      <Helmet>
        {GenerateMetaTags({
          title: '404: Ingenting ble funnet',
          description: 'Det ser ut som at ingenting ble funnet på denne siden.'
        })}
      </Helmet>

      <Breadcrumbs breadcrumbs={null} />

      <Title>404</Title>

      <Excerpt>
        <p>Det ser ut som at ingenting ble funnet på denne siden.</p>
      </Excerpt>

      <Content>
        <PrimaryLinkButton to="/">Gå til forsiden</PrimaryLinkButton>
      </Content>
    </StyledArticle>
  );
}
